export default "__VITE_ASSET__CAZPinlJ__"